// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralFillStealthHover, neutralForegroundHint, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { ComponentStyles } from "@microsoft/fast-jss-manager";
import { ProfileReportMenuClassNameContract } from "./ProfileReportMenu.classnames";

/**
 * The ReportMenu styles
 * @type {ComponentStyles<ProfileReportMenuClassNameContract, DesignSystem>}
 */
export const ProfileReportMenuStyles: ComponentStyles < ProfileReportMenuClassNameContract, DesignSystem > = {
    profileReportMenuContainer: {
        overflow: "hidden",
        position: "relative",
        width: "140px",
        background: neutralLayerCard,
        "border-radius": "8px",
        "box-shadow": "0px 0px 5.6px rgba(0, 0, 0, 0.11), 0px 6.4px 14.4px rgba(0, 0, 0, 0.13)",
        transition: ".2s ease",

        "& .cwt-sliding-container": {
            position: "absolute",
            bottom: "0",
            display: "flex",
            "align-items": "flex-end",
            transition: ".2s ease"
        },

        "& .cwt-report-list": {
            "min-width": "140px",
            "max-height": "188px",
            margin: "0",
            padding: "4px 0",
            "font-size": "12px",
            "letter-spacing": "-0.012em",
            "overflow-y": "auto",

            "& .cwt-menu-header": {
                "font-size": "16px",
                "margin-left": "auto",
                padding: "4px 12px",
                color: neutralForegroundHint,
                fill: "currentColor",

                "& .cwt-icon-label": {
                    "font-size": "12px",
                    "font-weight": "bold"
                }
            },

            "& li": {
                cursor: "pointer",
                padding: "4px 12px",
                color: neutralForegroundHint,

                "&:hover": {
                    background: neutralFillStealthHover
                }
            }
        }
    },

    profileReportMenuPopover: {
        bottom: "5px"
    }
};